<template>
  <div class="mobile-layout" :style="getBgStyle()">
    <slot />
  </div>
</template>

<script lang="ts" setup>
const getBgStyle = () => {
  return {
    backgroundImage: `url(${nameToImageOssUrl('m_r_bg.png')})`,
  };
};
</script>

<style lang="scss" scoped>
.mobile-layout {
  background-color: #000000;
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
  overflow: auto;
}
</style>
